import React from "react"
import { Input, Button, Space } from "antd"
import { SearchOutlined } from "@ant-design/icons"

const ColumnSearchFilter = ({
  setSelectedKeys,
  selectedKeys,
  confirm,
  clearFilters,
  dataIndex,
}) => {
  const handleSearch = () => {
    const trimmedValue = selectedKeys[0].trim()
    confirm()
    setSelectedKeys([trimmedValue])
  }

  const handleReset = () => {
    clearFilters()
    setSelectedKeys([])
    confirm() // This will trigger the table to update and remove the filter
  }

  return (
    <div style={{ padding: 8 }}>
      <Input
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value.trim()] : [])}
        onPressEnter={handleSearch}
        style={{ width: 188, marginBottom: 8, display: "block" }}
      />
      <Space>
        <Button
          type="primary"
          onClick={handleSearch}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90 }}>
          Search
        </Button>
        <Button onClick={handleReset} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </Space>
    </div>
  )
}

export default ColumnSearchFilter
